import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBusinessesResponse } from '../models/businesses.model';

export const loadBusinesses = createAction('[Businesses] Load Businesses');

export const loadBusinessesSuccess = createAction('[Businesses] Load Businesses Success', props<{ response: IBusinessesResponse[] }>());

export const loadBusinessesFailure = createAction('[Businesses] Load Businesses Failure', props<{ error: IGenericError<ErrorResponse> }>());
